import { render, staticRenderFns } from "./DetailedPricingCladifyItem.vue?vue&type=template&id=cb0a17a2&scoped=true"
import script from "./DetailedPricingCladifyItem.vue?vue&type=script&lang=js"
export * from "./DetailedPricingCladifyItem.vue?vue&type=script&lang=js"
import style0 from "./DetailedPricingCladifyItem.vue?vue&type=style&index=0&id=cb0a17a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0a17a2",
  null
  
)

export default component.exports